import { appDetails } from "~/utils/misc";

export default function support() {
  return (
    <div className="bg-background">
      <div className="flex flex-col p-8 bg-white mx-4 rounded-lg">
        <h2 className="text-2xl font-bold leading-9 tracking-tight text-foreground">
          Support
        </h2>
        <h3>
          {appDetails.title} by {appDetails.companyShortName}.
        </h3>
        <p className="text-gray-400 text-sm">Updated 26/10/2024</p>
      </div>
    </div>
  );
}
